import muniLogo from '../images/muni.png';
import edu from '../images/edu.png';
import uib from '../images/uib.png';

export const education = [
    {
        school: 'Masaryk University',
        studyProgram: 'Law and Legal science',
        between: '2011 - 2016',
        grade: 'Mgr.',
        logo: muniLogo,
        bio: "I obtained masters degree in the five year study programme Law and Legal Science at Masaryk University, covering wide range of legal fields.",
        bio_head: "Masaryk University - Faculty of Law",
        id: 1
    },
    {
        school: 'EDU Effective Business School',
        studyProgram: 'Bussiness Law',
        between: '2021-2022',
        grade: 'LL.M.',
        logo: edu,
        bio: "I obtained a professional LL.M. degree in the one year remote study programme Business law at EDU Effective Business School, covering bussiness law, negotiation, soft skills and other topics related to company management.",
        bio_head: "EDU Effective Bussiness School",
        id: 2
    },
    {
        school: 'Universitetet i Bergen',
        studyProgram: 'Law and Legal science',
        between: '2013',
        grade: 'Short-term study stay',
        logo: uib,
        bio: "I studied for 5 months at Universitet i Bergen, Norway, via Erasmus exchange programme (part of my legal degree at Masaryk University).",
        bio_head: "Universitet i Bergen",
        id: 3
    }
];